import React, { useEffect } from 'react';

import { Container } from '@lglp/components';
import { useDispatch } from 'react-redux';

import { setMainDocument } from '../../actions/main';
import { setUser } from '../../actions/user';
import { SSRComponent } from '../../types/component';

export const Page: SSRComponent<PageProps> = ({
  document,
  error,
  loading,
  children,
  ...rest
}) => {
  const dispatch = useDispatch();

  // Store the current document to redux.
  // If it's necessary, change to use context.
  useEffect(() => {
    dispatch(setMainDocument(document, error, loading));
  }, [document, error, loading, dispatch]);

  return <Container {...rest}>{children}</Container>;
};

Page.getInitialProps = async (serverData, { document, error }) => {
  serverData.store.dispatch(setUser(serverData.user));
  serverData.store.dispatch(setMainDocument(document, error, false));
  return serverData;
};

type PageProps = {
  document?: any;
  error?: any;
  loading?: boolean;
};
